import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';

export const slideInAnimation =
  trigger('routeAnimations', [
    transition('* => RedCarpetPage', [
      style({ position: 'relative' }),
      query(':enter', [
        style({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
          zIndex: 0
        })
      ]),
      query(':enter', [
        style({ right: '-100%' })
      ]),
      group([/*
        query(':leave', [
          animate('900ms ease-out', style({ right: '100%' }))
        ]), */
        query(':enter', [
          animate('900ms ease-out', style({ right: '0%' }))
        ])
      ]),
      query(':enter', animateChild()),
    ]),
    transition('* => TheaterPage', [
      style({ position: 'relative' }),
      query(':enter', [
        style({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
          zIndex: 0
        })
      ]),
      query(':enter', [
        style({ right: '-100%' })
      ]),
      group([/*
        query(':leave', [
          animate('900ms ease-out', style({ right: '100%' }))
        ]), */
        query(':enter', [
          animate('900ms ease-out', style({ right: '0%' }))
        ])
      ]),
      query(':enter', animateChild()),
    ])
  ]);
